import React from 'react';
import type { FlowId, SelfServiceData, StepId } from '../types';
import { useWizardStore } from './wizardStore';
import { shallow } from 'zustand/shallow';

export interface WizardContextValue {
  flowId: FlowId;
  selfServiceData: SelfServiceData;
  currentStepId: StepId;
  history: StepId[];
  sessionId: string | null;
  updateSelfServiceData: (field: string, value: unknown) => void;
  goToStep: (stepId: StepId, pushToHistory?: boolean) => void;
  goBack: () => void;
  goNext: () => void;
}

export const WizardProvider: React.FC<React.PropsWithChildren<{ value?: WizardContextValue }>> = ({ children }) => {
  return <>{children}</>;
};

export const useWizard = (): WizardContextValue => {
  return useWizardStore(state => ({
    flowId: state.flowId,
    selfServiceData: state.selfServiceData,
    currentStepId: state.currentStepId,
    history: state.history,
    sessionId: state.sessionId,
    updateSelfServiceData: state.updateSelfServiceData,
    goToStep: state.navHandlers.goToStep,
    goBack: state.navHandlers.goBack,
    goNext: state.navHandlers.goNext
  }), shallow);
};
